import { ResultValueType } from '@src/api';

export const unitsOptions = [
  { name: 'mmol', value: '149be056-0282-423b-b74a-ab71675c7702' },
  { name: '%', value: '6fcfba13-3cd5-46d8-b0c5-27887a0d5a9b' },
];
export const valueTypes = [
  {
    name: 'Single',
    value: ResultValueType.Single,
  },
  {
    name: 'Range',
    value: ResultValueType.Range,
  },
];
